import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import DefaultCard from '../../../../components/default/DefaultCard';
import WarehouseStorageDataTable from '../../../Quotes/subpages/WareHouseQuote/components/tables/WarehouseQuoteStorageDataTable';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { AppContext } from '../../../../contexts/AppContext';
import useWarehouseOrderStorageService from '../../../../app/services/hooks/useWareHouseOrderStorageService';
import { WarehouseOrderStorageDataForm } from '../../../../app/models/WareHouseOrderStorage';
import { WarehouseQuoteStorage, WarehouseQuoteStorageDataForm, WarehouseQuoteStorageFilters } from '../../../../app/models/WareHouseQuoteStorage';
import { Depot } from '../../../../app/models/Depot';
import DefaultModal from '../../../../components/default/DefaultModal';
import WarehouseQuoteStorageShow from '../../../Quotes/subpages/WareHouseQuote/components/WarehouseStorageShow';
import WarehouseOrderStorageShow from '../WarehouseOrderStorageShow';



interface Props {
    warehouseOrderId: number;
    // storages: WarehouseQuoteStorageDataForm;
    disableUpdate?: boolean;
    refresh?: number;
    isFormShow?: boolean;

}

const WarehouseOrderStorageContainer = ({ 
    warehouseOrderId,
    disableUpdate = false,
    isFormShow = false,
     refresh,
     }: Props) => {
    const {
        getAllWarehouseOrderStoragesByOrder,
        showWarehouseOrderStorage,
        fetchingGetWarehouseOrderStorages
    } = useWarehouseOrderStorageService();
    const [storages, setStorages] = useState<WarehouseOrderStorageDataForm>();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [warehouseQuoteStorages, setWarehouseQuoteStorages] = useState<WarehouseQuoteStorage[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseQuoteStorageFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    const [showingCreate, setShowingCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);
    const [storageIdEdit, setStorageIdEdit] = useState<number>(-1);
    const [storageIdShow, setStorageIdShow] = useState<number>(-1);
    const [showStorage, setShowStorage] = useState<WarehouseQuoteStorageDataForm>({});
    const [depots, setDepots] = useState<Depot[]>([]);

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setStorageIdEdit(id);
    };
    const showShow = (id: number) => {
        setShowingShow(true);
        setStorageIdShow(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setStorageIdEdit(-1);
    };
    const hideShow = () => {
        setShowingShow(false);
        setStorageIdShow(-1);
    };

    useEffect(() => {
        if (warehouseOrderId) reloadTable();
    }, [warehouseOrderId, filter, refresh]);

    const reloadTable = () => {
        getAllWarehouseOrderStoragesByOrder(warehouseOrderId,filter,{
            onSuccess: (response: ServiceResponse) => {
                setWarehouseQuoteStorages(response.data.warehouse_quote_storages);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    // const show = (id: number) => {
    //     showWarehouseOrderStorage(id, {
    //         onSuccess: (response: ServiceResponse) => {
    //             setShowStorage(response.data.storage);
    //             setShowingShow(true);
    //         }
    //     });
    // };




    return (
        <>
            <DefaultCard>
            <div className="h3 mt-0 mb-4 card-title">Dias libres</div> 
                <div className="row">
                    <div className="col-12">
                        <WarehouseStorageDataTable
                            warehouseQuoteStorages={warehouseQuoteStorages}
                            totalRows={totalRows}
                            loading={fetchingGetWarehouseOrderStorages}
                            show={showShow}
                            // edit={showEdit}
                            // destroy={destroy}
                            filter={filter}
                            setFilter={setFilter}
                            isShow={isFormShow}
                        />
                    </div>
                </div>
            </DefaultCard>
         {showingShow && (
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver información día libre"

            >
                <WarehouseOrderStorageShow 
                storageId={storageIdShow}
                onCancel={hideShow}
                // onError={hideShow}
                />
            </DefaultModal>
            )}
        </>
    );
};

export default WarehouseOrderStorageContainer;
